import { ExcelExportService } from '../../../../services/excel-export.service';
import { ReportsService } from '../../../../services/reports.service';
import { ReportParamsComponent } from '../report-params/report-params.component';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Settings } from '../../../../services/settings';
import { User } from 'src/app/models/user';
import { UserService } from '../../../../services/user.service';
import { MatLegacyListItem as MatListItem } from '@angular/material/legacy-list'

@Component({
	selector: 'app-reportsmain',
	templateUrl: './reportsmain.component.html',
	styleUrls: ['./reportsmain.component.css']
})
export class ReportsmainComponent implements OnInit {

	cols: any[];
	reports: any[];
	CurrentReportSelection: any;
	selectedReport: any;
	ReportData: Array<any>;
	ReportParams: Array<any>;
	displayParamsWindow = false;
	loading1 = false;
	loading2 = false;
	hasExcelExport = false;
	hasPrint = false;
	noDataFound = false;
	headerRHSData: string;
	headerLHSData: string;
	headerLHSReportName: string;
	params: Array<any>;
	@ViewChild(ReportParamsComponent, { static: true }) ReportParamsComp: ReportParamsComponent;

	constructor(private reportService: ReportsService, private userService: UserService, private excelExportService: ExcelExportService) {
		this.reportService.reportSpecificationsLoadedEvent$.subscribe(item => this.reportSpecificationsLoadedResultHandler(item));
		this.reportService.reportDataLoadedEvent$.subscribe(item => this.reportResultHandler(item));
		this.reportService.reportResultErrorEvent$.subscribe(item => this.reportResultErrorHandler());
	}

	ngOnInit() {

		this.cols = [
			{ field: 'name', header: 'Report Title', width: '100%' }
		];
		this.loading1 = true;
		this.reportService.getReportSpecifications().subscribe(
			reportList => {
				//this.reportSpecificationsLoadedResultHandler(reportList['result']);
				//this.loading1 = false;

				this.reports = reportList;
				this.loading1 = false;
			},
			(error) => {
				Settings.getInstance().handleError(error);
				this.loading1 = false;
			}
		);
		this.userService.getAllUsers().subscribe(
			userList => {
				Settings.getInstance().userList = userList;
			},
			(error) => {
				Settings.getInstance().handleError(error);
			}
		);
		this.hasExcelExport = Settings.getInstance().hasPrivilege('REPORTS_EXCEL_EXPORT', "EXECUTE");
		this.hasPrint = Settings.getInstance().hasPrivilege('REPORTS_PRINT', "EXECUTE");
	}
	reportSpecificationsLoadedResultHandler(data: any) {
		this.reports = data;
		this.loading1 = false;
	}
	onRowSelect(event) {
		this.CurrentReportSelection = event.data;
		this.ReportParamsComp.valSearchString = '';
		this.ReportData = [];
		this.noDataFound = false;
		this.headerRHSData = '';
		this.headerLHSData = '';
		this.headerLHSReportName = '';
	}
	RunClickHandler() {
		this.noDataFound = false;
		this.headerRHSData = '';
		this.headerLHSData = '';
		this.selectedReport = Object.assign({}, this.CurrentReportSelection);
		this.ReportData = [];
		this.ReportParams = null;
		this.ReportParamsComp.lblMessage = '';
		this.ReportParamsComp.checkDateDurationWarning();
		if (this.selectedReport.reportParams !== null && this.selectedReport.reportParams.length > 0) {
			this.ReportParams = this.selectedReport.reportParams;
			this.displayParamsWindow = true;
		} else {
			/** check to see if there is a service associated with this report **/
			if (this.selectedReport.service.length > 0) {
				this.loading2 = true;
				this.reportService.getReportData(this.selectedReport.service, []);
			}
			else {

			}
		}
	}
	reportResultHandler(data: any) {
		this.ReportData = data;
		this.loading2 = false;
		const nowDate = new Date();
		const date = (nowDate.getMonth() + 1) + '/' + nowDate.getDate() + '/' + nowDate.getFullYear();
		this.headerRHSData = 'Run: ' + date.toString();
		this.headerLHSReportName = this.CurrentReportSelection.name;
		this.headerLHSData = 'Filter: ';
		 
		if (this.params == null || this.params === undefined) {
			this.params = [];
		}
		for (const obj of this.params) {
			if (obj.name === 'UserUid') {
				if (this.headerLHSData === 'Filter: ') {
					this.headerLHSData = this.headerLHSData + ' ' + Settings.getInstance().getResourceFullName(obj.value) + ' (' + obj.value + ')';
				} else {
					this.headerLHSData = this.headerLHSData + ', ' + Settings.getInstance().getResourceFullName(obj.value) + ' (' + obj.value + ')';
				}
			} else if (obj.name === 'StartDate' && obj.value) {
				const date1 = new Date(obj.value);
				const year = date1.getUTCFullYear();
				const month = ('0' + (date1.getUTCMonth() + 1)).slice(-2);
				const day = ('0' + date1.getUTCDate()).slice(-2);
				const strDate = `${year}-${month}-${day}`;
				if (this.headerLHSData === 'Filter: ') {
					this.headerLHSData = this.headerLHSData + ' Start Date: ' + strDate;
				} else {
					this.headerLHSData = this.headerLHSData + ', Start Date: ' + strDate;
				}
			} else if (obj.name === 'EndDate' && obj.value) {
				const date1 = new Date(obj.value);
				const year = date1.getUTCFullYear();
				const month = ('0' + (date1.getUTCMonth() + 1)).slice(-2);
				const day = ('0' + date1.getUTCDate()).slice(-2);
				const strDate = `${year}-${month}-${day}`;
				this.headerLHSData = this.headerLHSData + ', End Date: ' + strDate;
			} else if (obj.name === 'County' && obj.value) {
				this.headerLHSData = this.headerLHSData + ', County: ' + obj.value;
			} else if (obj.name === 'RequestType' && obj.value) {
				this.headerLHSData = this.headerLHSData + ', Type	: ' + Settings.getInstance().getServiceRequestType(obj.value).description;
			} else if (obj.name === 'AgencyService' && obj.value) {
				this.headerLHSData = this.headerLHSData + ', Service	: ' + Settings.getInstance().getServiceDefDescription(obj.value);
			} else if (obj.name === 'Agency') {
				let agencyName;
				if (obj.value === -1) {
					agencyName = "All Agencies"
				} else {
					agencyName = Settings.getInstance().getAgencyName(obj.value);
				}
				if (agencyName && agencyName.length > 0) {
					if (this.headerLHSData === 'Filter: ') {
						this.headerLHSData = this.headerLHSData + ' Agency: ' + agencyName;
					} else {
						this.headerLHSData = this.headerLHSData + ', Agency: ' + agencyName;
					}
				}
			} else if (obj.name === 'CaseStatus' && obj.value) {
				if (this.headerLHSData === 'Filter: ') {
					this.headerLHSData = this.headerLHSData + ' Case Status: ' + Settings.getInstance().caseStatusList.find(rec => rec.id == obj.value).shortDescription;
				} else {
					this.headerLHSData = this.headerLHSData + ', Case Status: ' + Settings.getInstance().caseStatusList.find(rec => rec.id == obj.value).shortDescription;
				}
			} else if (obj.name === 'Source' && obj.value) {
				if (this.headerLHSData === 'Filter: ') {
					this.headerLHSData = this.headerLHSData + ' Source: ' + obj.value;
				} else {
					this.headerLHSData = this.headerLHSData + ', Source: ' + obj.value;
				}
			} else if (obj.name === 'DateType' && obj.value) {
				if (this.headerLHSData === 'Filter: ') {
					this.headerLHSData = this.headerLHSData + ' DateType: ' + (obj.value == 1 ? 'Created Date' : 'Closed Date');
				} else {
					this.headerLHSData = this.headerLHSData + ', DateType: ' + (obj.value == 1 ? 'Created Date' : 'Closed Date');
				}
			} else if (obj.name === 'AdvancedFilter') {
				if (this.headerLHSData === 'Filter: ') {
					this.headerLHSData = this.headerLHSData + ' ' + obj.name + ': ' + this.composeAdvanceFilterHeaderDisplayText();
				} else {
					this.headerLHSData = this.headerLHSData + ', ' + obj.name + ': ' + this.composeAdvanceFilterHeaderDisplayText();
				}
			} else if (obj.value) {
				if (this.headerLHSData === 'Filter: ') {
					this.headerLHSData = this.headerLHSData + ' ' + obj.name + ': ' + obj.value;
				} else {
					this.headerLHSData = this.headerLHSData + ', ' + obj.name + ': ' + obj.value;
				}
			}
		}
		if (this.ReportParams === undefined || this.ReportParams === null) {
			this.headerLHSData = 'Filter: NA';
		}

		if (data === undefined || data.length === 0) {
			this.noDataFound = true;
		} else {

		}
	} composeAdvanceFilterHeaderDisplayText() {
		let retVal = '';
		if (this.ReportParamsComp?.selectedAdvancedFilterQuery?.length) {
			for (let i = 0; i < this.ReportParamsComp.selectedAdvancedFilterQuery.length; i++) {
				const rec = this.ReportParamsComp.selectedAdvancedFilterQuery[i];
				if (i > 2) {
					retVal += ', ...';
					break;
				}
				const question = rec?.question || 'N/A';
				const response = rec?.response || 'N/A';
				retVal += `${question} : ${response}`;
				if (rec?.joins) {
					retVal += ` ${rec.joins} `;
				}
			}
		}
		return retVal || 'NA';
	}

	reportResultErrorHandler() {
		this.loading2 = false;
	}
	reportParamsRunClickHandler() {
		this.displayParamsWindow = false;
		this.loading2 = true;

		this.params = new Array<any>();
		for (let i = 0; i < this.selectedReport.reportParams.length; i++) {
			switch (this.selectedReport.reportParams[i].name) {
				case 'UserUid':
					this.params.push({ 'name': this.selectedReport.reportParams[i].name, 'value': this.ReportParamsComp.valSelectedEmployee });
					break;
				case 'StartDate':
					this.params.push({ 'name': this.selectedReport.reportParams[i].name, 'value': this.ReportParamsComp.valStartDate });
					break;
				case 'EndDate':
					this.params.push({ 'name': this.selectedReport.reportParams[i].name, 'value': this.ReportParamsComp.valEndDate });
					break;
				case 'Agency':
					this.params.push({ 'name': this.selectedReport.reportParams[i].name, 'value': this.ReportParamsComp.selectedAgency == null ? -1 : this.ReportParamsComp.selectedAgency });
					break;
				case 'DateType':
					this.params.push({ 'name': this.selectedReport.reportParams[i].name, 'value': this.ReportParamsComp.selectedDateType });
					break;
				case 'SearchString':
					this.params.push({ 'name': this.selectedReport.reportParams[i].name, 'value': this.ReportParamsComp.valSearchString });
					break;
				case 'MemberName':
					this.params.push({ 'name': this.selectedReport.reportParams[i].name, 'value': this.ReportParamsComp.selectedMember.id });
					break;
				case 'RequestType':
					this.params.push({ 'name': this.selectedReport.reportParams[i].name, 'value': this.ReportParamsComp.selectedRequestType });
					break;
				case 'AgencyService':
					this.params.push({ 'name': this.selectedReport.reportParams[i].name, 'value': this.ReportParamsComp.selectedAgencyService });
					break;
				case 'Region':
					this.params.push({ 'name': this.selectedReport.reportParams[i].name, 'value': this.ReportParamsComp.selectedZipCode });
					break;
				case 'County':
					this.params.push({ 'name': this.selectedReport.reportParams[i].name, 'value': this.ReportParamsComp.selectedCounty });
					break;
				case 'CaseStatus':
					this.params.push({ 'name': this.selectedReport.reportParams[i].name, 'value': this.ReportParamsComp.selectedCaseStatus });
					break;
				case 'Source':
					this.params.push({ 'name': this.selectedReport.reportParams[i].name, 'value': this.ReportParamsComp.selectedSource });
					break;
				case 'CaseNumber':
					this.params.push({ 'name': this.selectedReport.reportParams[i].name, 'value': this.ReportParamsComp.valCaseNumber });
					break;
				case 'AdvancedFilter':
					this.params.push({ 'name': this.selectedReport.reportParams[i].name, 'value': this.ReportParamsComp.isAdvanceFilterPresent });
					break;
			}
		}
		this.reportService.getReportData(this.selectedReport.service, this.params, this.ReportParamsComp.selectedAdvancedFilterQuery);
	}
	reportParamsCancelClickHandler() {
		this.displayParamsWindow = false;
	}
	excelClickHandler() {
		const data = new Array<any>();
		const obj1 = new Array<string>();
		obj1.push(this.headerLHSData);
		data.push(obj1);

		for (let i = 0; i < this.ReportData.length; i++) {
			const obj = new Array<any>();
			for (let j = 0; j < this.ReportData[i].length; j++) {
				const value = this.ReportData[i][j].label;
				if (this.ReportData[i][j].ignoreNumberParsing === true) {
					obj.push(value); // Push value as string
				} else {
					if (/^-?\d*\.?\d+$/.test(value)) { // Check if value is a valid number
						obj.push(Number.parseFloat(value)); // Parse value as float
					} else {
						obj.push(value); // Push value as string
					}
				}

			}
			data.push(obj);
		}

		this.excelExportService.exportArrayOfArrayAsExcelFile(data, this.selectedReport.name);
	}
	printClickHandler() {
		//const divToPrint= document.getElementById('reportPane');
		//let newWin: Window = window.open('');
		//newWin.document.write(divToPrint.outerHTML);
		//newWin.print();
		//newWin.close();
		let printContents, reportName, popupWin;
		printContents = document.getElementById('reportPane').innerHTML;
		reportName = this.CurrentReportSelection.Name;
		// popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');


		popupWin = this.popupCenter('_blank', 'Print Report', 760, 470);
		popupWin.document.title = 'Print';

		//popupWin.document.open();
		popupWin.document.write(`
		  <html>
			<head>
			  <title>${reportName}</title>
			  <link href="https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css" rel="stylesheet" />
			  <style type="text/css">
				  table { page-break-after:auto }
				  tr    { page-break-inside:avoid; page-break-after:auto }
				  td    { page-break-inside:avoid; page-break-after:auto }
				  thead { display:table-header-group ;}
				  tfoot { display:table-footer-group }
				  .no-print {
					display : inherit;
				  }
				  .print-only {
					display : none;
				  }
			
				  @media print {
				  
					 @page {
						size: landscape;
						font-size: 6pt!important;
						margin: 1cm;
					 }
					.print-only {
						display : block;
					}
					.no-print {
					  display : none;
					}
					header {
						position: fixed;
						top: 0;
					}
					footer { 
						display: inline-block;
						font-size: 8pt;	
					}
					.bold-text {
						font-weight: bold;
					}
					.header-row {
						border: gray;
						border-style: none;
						border-width: 1px;
						background-color: yellow;
						font-weight: bold;
					}
				  }
			  </style>
			</head>
			<body onload="window.print();window.close()">
			<header style="font-weight:bold;">
			Report: ${this.headerLHSReportName}<br />
			<span style="font-size: 9pt;font-weight:normal;">${this.returnFilterElements()}</span>
			</header><br />
			${printContents}</body>
		  </html>`
		);
		popupWin.document.close();
	}

	public returnFilterElements(): string {

		if (this.headerLHSData === 'Filter: ') {
			return 'Filter: <none>';
		}

		if (this.headerLHSData.length > 0) {
			return this.headerLHSData;
		}

		return '';
	}
	public popupCenter(url: string, title: string, w: number, h: number) {
		// Fixes dual-screen position                             Most browsers      Firefox
		const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
		const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

		const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
		const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

		const systemZoom = width / window.screen.availWidth;
		const left = (width - w) / 2 / systemZoom + dualScreenLeft
		const top = (height - h) / 2 / systemZoom + dualScreenTop
		const newWindow = window.open(url, title,
			`
		  scrollbars=yes,
		  width=${w / systemZoom}, 
		  height=${h / systemZoom}, 
		  top=${top}, 
		  left=${left}
		  
		  `
		)
		newWindow.document.body.style.background = 'gray';
		if (window.focus) newWindow.focus();
		return newWindow;
	}
	formatDateForTitle(date: Date | string): string {
		if (!date) {
			return '';
		}
		const dateObj = new Date(date);
		const year = dateObj.getFullYear();
		const month = ('0' + (dateObj.getMonth() + 1)).slice(-2); // Month is 0-indexed
		const day = ('0' + dateObj.getDate()).slice(-2);
		return `${year}-${month}-${day}`;
	}

}
